var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['item tw-mb-4 tw-flex tw-items-center tw-pl-4 tw-mb-4 secondary-c tw-cursor-pointer', { 'active tw-font-bold': _vm.active }],on:{"click":_vm.emitTabChange}},[_c('div',{staticClass:"tw-block"},[_vm._v(_vm._s(_vm.text))]),_c('i',{class:['fal fa-chevron-right tw-h-3 tw-ml-auto', { 'tw-font-bold': _vm.active }]})])
}
var staticRenderFns = []

export { render, staticRenderFns }